module.exports = __webpack_public_path__ + "img/appmastersoon.3c2cfb1a.png";